import React, { useLayoutEffect, useState } from 'react';
import { QuestRoute } from '../api/QuestRoutes';
import GetState from '../GetState';
import ModalFactory from '../Modal';

export const UserContexts = React.createContext();

const UsersContext = ({ children, ...props }) => {
    const [userGuid, setGuid] = useState(null);
    const [manualReset, setManualReset] = useState(false);
    const [user, refreshUser, setUser] = GetState(userGuid ? QuestRoute.user.info(userGuid) : null);
    const [washClub, refreshWC, setWC] = GetState(userGuid ? QuestRoute.user.washClub(userGuid) : null);
    const [CC, refreshCC, updateCC] = GetState(userGuid ? QuestRoute.user.creditCard(userGuid) : null);
    const [washClubList, setWashClubList] = useState([]);

    useLayoutEffect(() => {
        if (!userGuid || manualReset) {
            setManualReset(false);
            return;
        }

        setUser(null);
        setWC(null);
        updateCC(null);

        refreshUser()
        refreshWC();
        refreshCC();
    }, [userGuid]);

    const manualRefresh = async (guid) => {
        return new Promise(async (resolve, reject) => {
            setManualReset(true);
            try {
                await refreshUser(QuestRoute.user.info(guid));
                await refreshWC(QuestRoute.user.washClub(guid));
                await refreshCC(QuestRoute.user.creditCard(guid));
                setGuid(guid);
                resolve(true);
            } catch (error) {
                setManualReset(false);
                ModalFactory.catch(error);
                reject(false);
            }
        })
    };

    const contextValues = {
        user,
        setUser,
        refreshUser,

        washClub,
        setWC,
        refreshWC,

        CC,
        updateCC,
        refreshCC,

        userGuid,
        setGuid,
        manualRefresh,

        washClubList,
        setWashClubList,
    }

    return (
        <UserContexts.Provider value={contextValues}>
            {children}
        </UserContexts.Provider>
    );
}

export default UsersContext;